import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isProd } from 'helpers/helper';
import IntlMessages from 'helpers/IntlMessages';
import { UserContext } from 'contexts/user/UserContext';
import { resolveAnonymousHomeDestination } from './Auth/authLoopGuards';

const Home = (): React.ReactElement => {
  const { currentUser, isAuthenticated, loading } = useContext(UserContext);
  const history = useHistory();
  const [showRetry, setShowRetry] = useState(false);
  const landingPage = import.meta.env.VITE_HOME_URL || (isProd ? '/about' : '/login');

  useEffect(() => {
    if (!loading) {
      setShowRetry(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setShowRetry(true), 10000);
    return () => window.clearTimeout(timer);
  }, [loading]);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (isAuthenticated) {
      history.replace(currentUser?.username ? `/user/${currentUser.username}` : '/profile');
      return;
    }

    // A VITE_HOME_URL of "/" used to reload Home forever.
    window.location.replace(resolveAnonymousHomeDestination(landingPage, window.location.href));
  }, [currentUser?.username, history, isAuthenticated, landingPage, loading]);

  return showRetry && loading ? (
    <div role="alert">
      <p><IntlMessages id="general.loading-error" /></p>
      <button type="button" onClick={() => window.location.reload()}>
        <IntlMessages id="general.retry" />
      </button>
    </div>
  ) : <div className="loading" />;
};

export default Home;
